
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/sponsor-a-scholarship-success",
      function () {
        return require("private-next-pages/get-started/sponsor-a-scholarship-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/sponsor-a-scholarship-success"])
      });
    }
  